import React, { Component } from 'react';
import SubmitButton from './submit-button';

export default class Form extends Component {
  render() {
    const { disabled, buttonText, ...props } = this.props;

    return (
      <form {...props}>
        {this.props.children}

        {buttonText ? (
          <SubmitButton label={buttonText} disabled={disabled} />
        ) : null}
      </form>
    );
  }
}
